import React from 'react'
import { alpha } from '@mui/material/styles'
import { Button, Box } from '@mui/material'
import PropTypes from 'prop-types'
import LanguageIcon from '@mui/icons-material/Language'
import { Preview } from './common/style'
import Screenshots from './common/Screenshots'
import Summary from './common/Summary'
import Contribution from './common/Contribution'
import { ProjectDialogContent } from '.'

export default function ProjectLawLogging({ color, screenshots, summary, contribution }) {

  return (
    <ProjectDialogContent>
      <Preview alt='growup' src='/static/works/lawlogging.png' />
      <Box
        sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center', mb: 10 }}
      >
        <Button
          size='large'
          variant='contained'
          startIcon={<LanguageIcon />}
          disabled
          sx={{ '&.Mui-disabled': { color, backgroundColor: alpha(color, 0.12), border: `1px solid ${alpha(color, 0.25)}` }, textTransform: 'none' }}
        >
          {'Web (currently unavailable)'}
        </Button>
      </Box>
      <Summary color={color} summary={summary} />
      <Contribution color={color} contribution={contribution} />
      <Screenshots color={color} screenshots={screenshots} alt='lawlogging' />
    </ProjectDialogContent>
  )
}

ProjectLawLogging.propTypes = {
  color: PropTypes.string,
  screenshots: PropTypes.array,
  summary: PropTypes.object,
  contribution: PropTypes.array
}
